const filterActionTypes = {
	SET_APPLIED_FACETS: 'SET_APPLIED_FACETS',
	CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
	CLEAR_FILTER: 'CLEAR_FILTER',
	CLEAR_FACET: 'CLEAR_FACET',
	FETCH_ALL_FILTERS_SUCCESS: 'FETCH_ALL_FILTERS_SUCCESS',
	FETCH_ALL_FILTERS_FAILURE: 'FETCH_ALL_FILTERS_FAILURE',
};
export default filterActionTypes;
